export default {
  desktop: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/layouts/desktop.vue").then(m => m.default || m),
  maintenance: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/layouts/maintenance.vue").then(m => m.default || m),
  mobile: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/layouts/mobile.vue").then(m => m.default || m)
}